import React, { Component } from 'react';
import { DateRangePicker } from 'react-dates';
import ReactTable from 'react-table';
import Select from 'react-select';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import moment from 'moment';
import makeAnimated from 'react-select/lib/animated';
import update from 'immutability-helper';

import 'react-table/react-table.css';
import 'react-dates/lib/css/_datepicker.css';

class OrdersList extends Component {

    constructor() {
        super();

        this.toggleFilters = this.toggleFilters.bind(this);
        this.getOrders = this.getOrders.bind(this);
        this.refreshTable = this.refreshTable.bind(this);
        this.filterSearch = this.filterSearch.bind(this);
        this.handleFocusChange = this.handleFocusChange.bind(this);
        this.handleDatesChange = this.handleDatesChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleInput = this.handleInput.bind(this);

        this._orderFocusChange = this.handleFocusChange('order').bind(this);
        this._orderDatesChange = this.handleDatesChange('order').bind(this);
        this._paymentFocusChange = this.handleFocusChange('payment').bind(this);
        this._paymentDatesChange = this.handleDatesChange('payment').bind(this);

        this.Configurations = new Configurations();

        this.productOptions = [
            { label: "Brasil Seikyo Português", value: "1" },
            { label: "Brasil Seikyo Japonês", value: "2" },
            { label: "Terceira Civilização", value: "3" },
            { label: "RDez", value: "4" },
            { label: "BS+", value: "5" },
            { label: "Brasil Seikyo Digital", value: "6" },
            { label: "Daibyakurenge", value: "7" }
        ]

        this.orderStatusOptions = [
            { label: "Pedido Feito", value: 1 },
            { label: "Aguardando Vigência", value: 2 },
            { label: "Vigência em andamento", value: 3 },
            { label: "Vigência Finalizada", value: 4 },
            { label: "Pedido não pago", value: 5 },
            { label: "Pedido Cancelado", value: 6 },
            { label: "Pedido Brinde", value: 7 }
        ]

        this.paymentStatusOptions = [
            { label: "Aguardando pagamento", value: 1 },
            { label: "Pago", value: 2 },
            { label: "Pago parcial", value: 3 },
            { label: "Vencido", value: 4 },
            { label: "Negado", value: 5 },
            { label: "Baixa manual", value: 6 },
            { label: "Brinde", value: 8 }
        ]

        this.state = {
            openFilters: true,
            filters: {
                order: {},
                payment: {},
                productList: [],
                orderStatusList: [],
                paymentStatusList: []
            },
            codMembroBusca: '',
            buscaRealizada: false,
            alertaBuscaMembro: false,
        }

        this._phrases = {
            closeDatePicker: "Fechar",
            clearDates: "Limpar datas",
            calendarLabel: "Calendário"
        }

        this.columns = [
            {
                Header: 'Pedido',
                accessor: 'numeroPedido',
                className: 'text-center pointer',
                width: 55
            },
            {
                Header: 'Solicitante',
                className: 'pointer',
                accessor: 'nomeSolicitante',
                
            },
            {
                Header: 'Cod.Membro',
                accessor: 'codMembroSolicitante',
                className: 'pointer text-center',
                width: 80,
                Cell: row => (<span className={row.value ? '' : 'badge badge-secondary'}> {row.value ? row.value : 'Não membro'}</span>)
               

            },
            {
                Header: 'Valor',
                accessor: 'valorPedido',
                // accessor: 'valorPago',
                className: 'text-center pointer',
                width: 90,
                Cell: row => (<span>R$ {row.value !== undefined && row.value !== null ? row.value.toFixed(2).toString().replace('.', ',') : "0,00"}</span>)
            },
            {
                Header: 'Dt. pedido',
                accessor: 'dtPedido',
                className: 'pointer text-center',
                width: 100,
                Cell: row => (<span>{moment(row.value).format('DD/MM/YY HH:mm')}</span>)
            },
            {
                Header: 'Dt. pagto.',
                accessor: 'dtPagto',
                className: 'pointer text-center',
                width: 100,
                Cell: row => (<span>{row.value !== undefined && row.value !== null ? moment(row.value).format('DD/MM/YY HH:mm') : '-'}</span>)
            },
            {
                Header: 'RA',
                accessor: 'recorrente',
                className: 'text-center pointer',
                width: 60,
                Cell: row => (<span className={`badge badge-${row.value ? 'info' : ''}`}>{row.value ? 'RA' : ''}</span>)
            },
            {
                Header: 'Status pedido',
                accessor: 'statusPedido',
                className: 'text-center pointer',
                width: 110,
                Cell: row => (<span className={`badge badge-${this.orderBadgeType(row.value)}`}>{row.value}</span>)
            },
            {
                Header: 'Status pagto.',
                accessor: 'statusPagto',
                className: 'text-center pointer',
                width: 110,
                Cell: row => (<span className={`badge badge-${this.paymentBadgeType(row.value)}`}>{row.value}</span>)
            },

            // {
            //     Header: 'Produto(s)',
            //     accessor: 'produto',
            //     className: 'text-center pointer',
            //     width: 120,
            //     Cell: row => (
            //         row.value.map((item, index) => {
            //             return <span key={index} className={`badge badge-${this.productBadgeType(item)} mx-1`}>{item}</span>
            //         })
            //     )
            // },
            {
                Header: 'Produto(s)',
                accessor: 'nomeProduto',
                className: 'text-center pointer',
                // width: 120,
                Cell: row => (
                    row.value.map((item, index) => {
                        return <p style={{fontSize: 10}} key={index} className="m-0">{item}</p>
                    })
                )
            },
        ]
    }
    handleInput(e) {
        e.preventDefault();
        const _name = e.target.name
        this.setState({ [_name]: e.target.value })
    }

    orderBadgeType(status) {
        switch (status.toLowerCase()) {
            case "pedido feito":
                return "primary";
            case "aguardando vigência":
                return "primary";
            case "vigência em andamento":
                return "primary";
            case "vencido":
                return "danger";
            case "pedido cancelado":
                return "danger";
            default:
                return "warning";
        }
    }

    paymentBadgeType(status) {
        switch (status.toLowerCase()) {
            case "pago":
                return "success";
            case "vencido":
                return "secondary";
            case "negado":
                return "danger";
            case "baixa manual":
                return "primary";
            default: // case 1, 3
                return "warning";
        }
    }

    productBadgeType(status) {
        switch (status) {
            case "BS":
                return "primary";
            case "TC":
                return "danger";
            case "RD":
                return "warning";
            default:
                return "info";
        }
    }

    handleSelectChange(e, o) {
        const _name = o.name;
        let _list = this.state.filters[_name];
        // console.log(o);
        switch (o.action) {
            case "remove-value":
                const _index = _list.findIndex(item => item === o.removedValue);
                _list.splice(_index, 1);
                //-- do
                break;
            case "clear":
                const _filters = this.state.filters;
                _filters[_name] = [];
                this.setState({
                    filters: _filters
                });
                return o;
            default:
                _list.push(o.option);
                break;
        }

        const _filters = update(this.state.filters, { $merge: { [_name]: _list } });
        this.setState({ _filters });

        return o;
    }

    toggleFilters() {
        this.setState({
            openFilters: !this.state.openFilters
        })
    }

    // pedidos/idpedido/estorno
    getOrders(o) {
        // console.log("o: ", o)
        this.setState({ loading: true });

        const _params = [];

        if (!o.pageSize) {
            o.pageSize = 20;
            _params.push(`qtdItens=${o.pageSize}`);
        } else if (!(o.page + 1)) {
            o.page = 1;
            _params.push(`pagina=${o.page}`);
            o.sorted = []
            _params.push(`ordenacao=${o.sorted.map(item => item.id).join(',')}`);
        } else {
            _params.push(`qtdItens=${o.pageSize}`);
            _params.push(`pagina=${o.page + 1}`);
        }

        if (this.state.filters.paymentStatusList.length > 0) {
            _params.push(`statusPgto=${this.state.filters.paymentStatusList.map(item => item.value).join(',')}`);
        }

        if (this.state.filters.orderStatusList.length > 0) {
            _params.push(`statusPedido=${this.state.filters.orderStatusList.map(item => item.value).join(',')}`);
        }

        if (this.state.filters.productList.length > 0) {
            _params.push(`idsProdutos=${this.state.filters.productList.map(item => item.value).join(',')}`);
        }

        if (this.state.filters.payment.startDate && this.state.filters.payment.endDate) {
            _params.push(`dtInicioPgto=${moment(this.state.filters.payment.startDate).format()}`);
            _params.push(`dtFimPgto=${moment(this.state.filters.payment.endDate).format()}`);
        }

        if (this.state.filters.order.startDate && this.state.filters.order.endDate) {
            _params.push(`dtInicioCriacao=${moment(this.state.filters.order.startDate).format()}`);
            _params.push(`dtFimCriacao=${moment(this.state.filters.order.endDate).format()}`);
        }

        const _orders = axios.get(this.Configurations.apiBasePath + `/pedidos?${_params.join('&')}`);

        const _parametros = _params.join('&');

        _orders.then(response => {
            this.setState({
                ordersList: response.data.data.pedidos,
                pages: response.data.data.paginacao.totalPaginas,
                loading: false,
                parametros: _parametros
            });
        }).catch(err => {
            console.log(err);
        });
    }

    handleFocusChange(attr) {
        return function (focusedInput) {
            var dates = this.state.filters[attr];

            dates.focusedInput = focusedInput;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }

    handleDatesChange(attr) {
        return function ({ startDate, endDate }) {
            var dates = this.state.filters[attr];
            dates.startDate = startDate;
            dates.endDate = endDate;
            startDate ? dates.gte = startDate.format('YYYY[-]MM[-]DD') : delete dates.gte;
            endDate ? dates.lte = endDate.format('YYYY[-]MM[-]DD') : delete dates.lte;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }

    refreshTable(o) {
        this.getOrders(o);
    }

    _outsideRange(day) {
        return day.format() > moment().format();
    }

    filterSearch(e) {
        e.preventDefault();
        // this.salvaParametros();
        this.getOrders({});
    }

    render() {
        return (
            <div className="order-list">
                <div className="row">
                    <div className="col-10">
                        <h2 className="title-1">Pedidos</h2>
                    </div>
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header p-2" id="headingOne">
                                <div className="col-12">
                                    <button className="btn btn-link w-100 text-left" type="button" onClick={this.toggleFilters}>
                                        <i className={`fa mr-2 ${this.state.openFilters ? "fa-chevron-right" : "fa-chevron-down"}`}></i>
                                        Filtros
                                    </button>
                                </div>
                            </div>
                            <div className={`card-body ${!this.state.openFilters && "collapse"}`} id="boxFilters">
                                {this.state.loading ? (
                                    <div className="row no-gutters">
                                        <div className="col-12 text-center py-5">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    </div>
                                ) : (
                                        <form onSubmit={this.filterSearch} noValidate>
                                            <div className="row">
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="dpStartDate">Período de solicitação</label><br />
                                                        <DateRangePicker
                                                            showClearDates
                                                            enableOutsideDays
                                                            isOutsideRange={this._outsideRange}
                                                            startDate={this.state.filters.order.startDate} // momentPropTypes.momentObj or null,
                                                            startDateId="dpStartDate" // PropTypes.string.isRequired,
                                                            endDate={this.state.filters.order.endDate} // momentPropTypes.momentObj or null,
                                                            endDateId="dpEndDate" // PropTypes.string.isRequired,
                                                            onDatesChange={this._orderDatesChange} // PropTypes.func.isRequired,
                                                            focusedInput={this.state.filters.order.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                                            onFocusChange={this._orderFocusChange}
                                                            displayFormat="DD/MM/YYYY"
                                                            startDatePlaceholderText="Data inicial"
                                                            endDatePlaceholderText="Data final"
                                                            phrases={this._phrases}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="dpPayStartDate">Período de pagamento</label><br />
                                                        <DateRangePicker
                                                            showClearDates
                                                            enableOutsideDays
                                                            isOutsideRange={this._outsideRange}
                                                            startDate={this.state.filters.payment.startDate} // momentPropTypes.momentObj or null,
                                                            startDateId="dpPayStartDate" // PropTypes.string.isRequired,
                                                            endDate={this.state.filters.payment.endDate} // momentPropTypes.momentObj or null,
                                                            endDateId="dpPayEndDate" // PropTypes.string.isRequired,
                                                            onDatesChange={this._paymentDatesChange} // PropTypes.func.isRequired,
                                                            focusedInput={this.state.filters.payment.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                                            onFocusChange={this._paymentFocusChange} // PropTypes.func.isRequired,
                                                            displayFormat="DD/MM/YYYY"
                                                            startDatePlaceholderText="Data inicial"
                                                            endDatePlaceholderText="Data final"
                                                            phrases={this._phrases}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ddlStatusPedido">Status Pedido</label>
                                                        <Select
                                                            id="ddlStatusPedido"
                                                            placeholder="Selecione um ou mais status"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.filters.orderStatusList}
                                                            isMulti
                                                            name="orderStatusList"
                                                            onChange={this.handleSelectChange}
                                                            options={this.orderStatusOptions}
                                                            
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ddlProducts">Produtos</label>
                                                        <Select
                                                            id="ddlProducts"
                                                            placeholder="Selecione um ou mais produtos"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            isMulti
                                                            defaultValue={this.state.filters.productList}
                                                            options={this.productOptions}
                                                            onChange={this.handleSelectChange}
                                                            name="productList"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="offset-4 col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ddlStatusPagamento">Status Pagamento</label>
                                                        <Select
                                                            id="ddlStatusPagamento"
                                                            placeholder="Selecione um ou mais status"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.filters.paymentStatusList}
                                                            isMulti
                                                            name="paymentStatusList"
                                                            onChange={this.handleSelectChange}
                                                            options={this.paymentStatusOptions}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 text-right">
                                                    <button className="btn btn-primary">Buscar</button>
                                                </div>
                                            </div>
                                        </form>

                                    )}

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="card tabela-pedidos">
                            <div className="card-body p-0">
                                <ReactTable
                                    data={this.state.ordersList}
                                    columns={this.columns}
                                    onFetchData={this.refreshTable}
                                    defaultPageSize={20}
                                    pages={this.state.pages}
                                    manual
                                    loading={this.state.loading}
                                    className="-striped -highlight"
                                    headerClassName="ebs-table-header"
                                    previousText='Anterior'
                                    nextText='Próximo'
                                    loadingText='Carregando...'
                                    noDataText='Nenhum pedido encontrado.'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='linhas'
                                    getTrProps={(state, rowInfo, column, instance) => {
                                        return {
                                            onClick: (e, handleOriginal) => {
                                                this.props.history.push({ pathname: `/pedidos/detalhes/${rowInfo.original.numeroPedido}` })
                                            }
                                        }
                                    }}

                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default OrdersList;